
import type { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  hover?: boolean;
}

export default function Card({ children, className = '', hover = true }: CardProps) {
  return (
    <div 
      className={`
        bg-white rounded-xl border border-blue-100 p-6 
        ${hover ? 'hover:shadow-colored hover:border-blue-200 hover:-translate-y-2 transform transition-all duration-500' : 'shadow-soft'} 
        ${className}
      `}
    >
      {children}
    </div>
  );
}